import type { StackStyleBase } from "@tamagui/web";

type ShadowStyle = Pick<StackStyleBase, "boxShadow">;

export const shadow = {
  /** Used for plates and card shadows */
  light: {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  /** Used for floating controls and dialogues */
  medium: {
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
  },
  /** Used for desktop web dialogues. */
  heavy: {
    boxShadow: "0px 16px 64px rgba(0, 0, 0, 0.12)",
  },
} as const satisfies Record<string, ShadowStyle>;

export type ShadowVariant = keyof typeof shadow;
